import React, { useRef } from "react";
import { Carousel } from "@mantine/carousel";
import { Paper, Group, Image } from "@mantine/core";
import AutoScroll from 'embla-carousel-auto-scroll';
import { useNavigate } from "react-router-dom"; // Если используете react-router
import S from './Partners.module.scss';
import { partnersData } from "../../shared/mock/partners";

export const Partners = () => {
  const navigate = useNavigate();
  const autoScroll = useRef(
    AutoScroll({
      speed: 1,
      stopOnInteraction: false,
      stopOnMouseEnter: true,
    })
  );

  return (
    <div className={S.partners} id="partners">
      <div className={S.partnerContainer}>
        <h1 className={S.title}>ПАРТНЕРЫ</h1>
      </div>

      <Carousel
        slideSize={{ base: '200px', sm: '300px', md: '360px' }} // Адаптивный размер
        slideGap="md"
        withControls={false}
        withIndicators={false}
        plugins={[autoScroll.current]}
        emblaOptions={{ align: 'start', loop: true, dragFree: true }}
        className={S.carousel}
      >
        {partnersData.map((partner) => (
          <Carousel.Slide key={partner.id}>
            <Paper
              className={S.partnerCard}
              onClick={() => navigate(`/brands/${partner.id}`)}
            >
              <Group className={S.partnerCardImg} justify="center" h="100%">
                <Image
                  src={partner.images}
                  alt={partner.title}
                  className={S.partnerLogo}
                  fit="contain"
                />
              </Group>
            </Paper>
          </Carousel.Slide>
        ))}
      </Carousel>
    </div>
  );
};
